export default __webpack_public_path__ + "static/media/close~HPDVQtfM.c957ccc5.svg";